/**
 * Arte de las cartas.
 *
 * ARCHIVO GENERADO. No editar a mano.
 * Regenerar con: node scripts/generate-card-placeholders.mjs
 *
 * Para poner la ilustración definitiva de una carta, SUSTITUYE el PNG de esta
 * carpeta conservando el nombre. No hay que tocar este índice, ni el catálogo,
 * ni el componente: Vite resuelve la ruta y le pone su hash al empaquetar.
 *
 * Tamaño de referencia: 360x504 (proporción 5:7, la de la carta).
 */

import card_squire_01 from './card_squire_01.png';
import card_scout_01 from './card_scout_01.png';
import card_wolf_01 from './card_wolf_01.png';
import card_bard_01 from './card_bard_01.png';
import card_saboteur_01 from './card_saboteur_01.png';
import card_golem_01 from './card_golem_01.png';
import card_alchemist_01 from './card_alchemist_01.png';
import card_priestess_01 from './card_priestess_01.png';
import card_knight_01 from './card_knight_01.png';
import card_warlock_01 from './card_warlock_01.png';
import card_titan_01 from './card_titan_01.png';
import card_dragon_01 from './card_dragon_01.png';

export const CARD_ART: Record<string, string> = {
  card_squire_01,
  card_scout_01,
  card_wolf_01,
  card_bard_01,
  card_saboteur_01,
  card_golem_01,
  card_alchemist_01,
  card_priestess_01,
  card_knight_01,
  card_warlock_01,
  card_titan_01,
  card_dragon_01,
};
